import { CONTACT_SUPPORT_LINK } from '~/javascripts/constants';
import { BASE_ERROR_DICTIONARY } from '~/javascripts/lib/error_dictionary';
import { sprintf, __ } from '~/javascripts/lib/locale';
import { convertObjectPropsToLowerCase } from '../lib/convert_utils';

// Note: `links` map keys MUST match up to `message` placeholder values to properly create a href
// Ex: message: 'If the problem persists, %{supportLinkStart}contact support%{supportLinkEnd}.,
//     links: {
//       supportLink: CONTACT_SUPPORT_LINK,
//     },
const ZUORA_ACCOUNT_ID_INVALID = 'zuora_account_id:invalid';
const ZUORA_ACCOUNT_ID_INVALID_ERROR_MAP = {
  title: '',
  message: __(
    'Account not found. If the problem persists, %{supportLinkStart}contact support%{supportLinkEnd}.',
  ),
  links: { supportLink: CONTACT_SUPPORT_LINK },
};

const INVALID_BILLING_ACCOUNT_UPDATE_ERROR_TITLE = __(
  'Could not update billing account information',
);

const UPDATE_BILLING_ACCOUNT_ATTRIBUTE_MAP = (message) => ({
  title: INVALID_BILLING_ACCOUNT_UPDATE_ERROR_TITLE,
  message,
});

// `too_long` comes from Rails ActiveRecord length validator
const lengthError = 'too_long';
const lengthErrorMessage = (field, maxChar) =>
  sprintf(__('%{field} must be %{maxChar} characters or less.'), { field: __(field), maxChar });

// `blank` comes from Rails ActiveRecord presence validator
const ZUORA_ACCOUNT_NAME_BLANK_ERROR_TYPE = 'zuora_account_name:blank';
const ZUORA_ACCOUNT_NAME_BLANK_ERROR_MAP = UPDATE_BILLING_ACCOUNT_ATTRIBUTE_MAP(
  __('Company name is required.'),
);
const ZUORA_ACCOUNT_NAME_LENGTH_ERROR_TYPE = `zuora_account_name:${lengthError}`;
const ZUORA_ACCOUNT_NAME_LENGTH_ERROR_MAP = UPDATE_BILLING_ACCOUNT_ATTRIBUTE_MAP(
  lengthErrorMessage('Company name', 255),
);

// Should be refactored to using `tax`-names instead of `vat`:
// https://gitlab.com/gitlab-org/customers-gitlab-com/-/issues/7469
const ZUORA_ACCOUNT_TAX_ID_LENGTH_ERROR_TYPE = `zuora_account_vat_id:${lengthError}`;
const ZUORA_ACCOUNT_TAX_ID_LENGTH_ERROR_MAP = UPDATE_BILLING_ACCOUNT_ATTRIBUTE_MAP(
  lengthErrorMessage('Tax ID', 25),
);

const TOO_MANY_INVITES_ERROR_TYPE = 'billing_account:too_many_invites';
const TOO_MANY_INVITES_ERROR_MAP = {
  title: '',
  message: __(
    'You cannot invite more managers because too many invitations are pending. Please %{supportLinkStart}contact support%{supportLinkEnd} to remove the pending invitations.',
  ),
  links: { supportLink: CONTACT_SUPPORT_LINK },
};

const MEMBERSHIP_PRIMARY_ACCOUNT = 'membership:primary_account';
const PRIMARY_ACCOUNT_ERROR_MAP = {
  title: __('Account cannot be deleted'),
  message: __(
    'The account cannot be deleted since the member is a bill to / sold to contact on the account.',
  ),
};

const NOT_AUTHORIZED_INVITATION = 'base:not_authorized_invitation';
const NOT_AUTHORIZED_INVITATION_ERROR_MAP = {
  title: __('You are not authorized to delete this invitation.'),
};

const NOT_AUTHORIZED_MEMBERSHIP = 'base:not_authorized_membership';
const NOT_AUTHORIZED_MEMBERSHIP_ERROR_MAP = {
  title: __('You are not authorized to delete this membership.'),
};

export const BILLING_ACCOUNT_ERROR_DICTIONARY = convertObjectPropsToLowerCase({
  ...BASE_ERROR_DICTIONARY,

  [NOT_AUTHORIZED_INVITATION]: NOT_AUTHORIZED_INVITATION_ERROR_MAP,
  [NOT_AUTHORIZED_MEMBERSHIP]: NOT_AUTHORIZED_MEMBERSHIP_ERROR_MAP,
  [MEMBERSHIP_PRIMARY_ACCOUNT]: PRIMARY_ACCOUNT_ERROR_MAP,

  [ZUORA_ACCOUNT_ID_INVALID]: ZUORA_ACCOUNT_ID_INVALID_ERROR_MAP,
  [ZUORA_ACCOUNT_NAME_BLANK_ERROR_TYPE]: ZUORA_ACCOUNT_NAME_BLANK_ERROR_MAP,
  [ZUORA_ACCOUNT_NAME_LENGTH_ERROR_TYPE]: ZUORA_ACCOUNT_NAME_LENGTH_ERROR_MAP,
  [ZUORA_ACCOUNT_TAX_ID_LENGTH_ERROR_TYPE]: ZUORA_ACCOUNT_TAX_ID_LENGTH_ERROR_MAP,
  [TOO_MANY_INVITES_ERROR_TYPE]: TOO_MANY_INVITES_ERROR_MAP,
});
